export const ALL_COUNTRY_CODES: ReadonlyArray<string> = [
  'BRA', // Brasil
  'ARG', // Argentina
  'CHL', // Chile
  'URY', // Uruguai
  'PRY', // Paraguai
  'BOL', // Bolívia
  'PER', // Peru
  'ECU', // Equador
  'COL', // Colômbia
  'VEN', // Venezuela
  'MEX', // México
  'PAN', // Panamá
  'CRI', // Costa Rica
  'GTM', // Guatemala
  'HND', // Honduras
  'NIC', // Nicarágua
  'SLV', // El Salvador
  'DOM', // República Dominicana
];

export const COUNTRY_ALPHA3_TO_ALPHA2: Readonly<Record<string, string>> = {
  ARG: 'AR',
  BOL: 'BO',
  BRA: 'BR',
  CHL: 'CL',
  COL: 'CO',
  CRI: 'CR',
  DOM: 'DO',
  ECU: 'EC',
  GTM: 'GT',
  HND: 'HN',
  MEX: 'MX',
  NIC: 'NI',
  PAN: 'PA',
  PER: 'PE',
  PRY: 'PY',
  SLV: 'SV',
  URY: 'UY',
  VEN: 'VE',
};
